// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"7b7cea86","215":"9b4ed614","375":"a73c958a","827":"a3adf5d3","831":"3b9afdf1","845":"3aafdf2d","993":"3ae3778e"}[chunkId] + ".chunk.js";
};